import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { CallDetails } from 'src/app/models/commission/call-details.model';
import { EntFeed } from 'src/app/models/commission/ent-feed.model';
import { FreeForm } from 'src/app/models/commission/free-form.model';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { MobileFeedModel } from 'src/app/models/commission/mobile-feed.model';
import { RntFeedModel } from 'src/app/models/commission/rnt-feed.model';
import { RegionsModel } from 'src/app/models/manageRegions/regions.model';
import { CommissionService } from 'src/app/service/commission.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { ManageRegionsService } from 'src/app/service/manage-regions.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-feed-adjustments',
  templateUrl: './feed-adjustments.component.html',
  styleUrls: ['./feed-adjustments.component.css']
})
export class FeedAdjustmentsComponent implements OnInit {
  freeFormResult: FreeForm[];
  feedCallResultsData: CallDetails[];

  public majorAreasList: RegionsModel[] = [];
  public corpsList: RegionsModel[] = [];

  public komFeedModel = new KomFeed();
  public callDetailModel = new CallDetails();
  public mobileFeedModel = new MobileFeedModel();
  public entFeedModel = new EntFeed();
  public rntFeedModel = new RntFeedModel();
  

  public feedData: string[] = [];
  public entFeedTypes: string[] = [];
  public enterpriseStatuses: string[] = [];
  public salesRepData: KomFeed[] = [];
  public feedResultsData: KomFeed[] = [];
  public mobileFeedResultsData: MobileFeedModel[] = [];
  public entFeedResultsData: EntFeed[] = [];
  public rntFeedResultsData: RntFeedModel[] = [];
  public freeForm = new FreeForm();
  public columnsData: any;
  public ordersTableColumns: TableColumn[];
  public resHeadder: string = 'Free Form Search Results';
  public chc: any[] = [];
  public isKomFeed: boolean = false;
  public isEnterprise: boolean = false;
  public isEntRelease: boolean = false;
  public isRetention: boolean = false;
  public isCall: boolean = false;
  public isMobile: boolean = false;
  public isRnt: boolean = false;
  public isEntFeed: boolean = false;
  public isAll: boolean = false;
  public rntFilterOptions: any = {};
  private rntMainFilterOptionsLoaded = false;

  constructor(private komFeedService: KomFeedService, private commissionService: CommissionService, private datePipe: DatePipe,
    private router: Router, private notificationService: NotificationService, private manageRegionsService: ManageRegionsService,
    private httpService: HttpClient) { }


  ngOnInit(): void {
    this.init()
    this.callDetailModel.kom_call_id
  }

  init() {

    this.feedData.push('KOM Feed');
    // this.feedData.push('KOM Feed Retention');
    this.feedData.push('Mobile Feed');
    this.feedData.push('RTN Feed');
    // this.feedData.push('Call Details');
    this.feedData.push('ENT Feed');
    // this.feedData.push('All');
    this.entFeedTypes.push('Enterprise Data');
    this.entFeedTypes.push('Enterprise Release Data');

    this.enterpriseStatuses.push("Paid");
    this.enterpriseStatuses.push("Cancel");
    
    this.enterpriseStatuses.push("calculated");
    

    this.komFeedModel.adjustmentFeed = localStorage.getItem('adjustment_komfeed');
    console.log(this.komFeedModel.adjustmentFeed);
    this.komFeedModel.corp = localStorage.getItem('adjustment_corp');
    this.komFeedModel.house = localStorage.getItem('adjustment_house');
    this.komFeedModel.orderFromDate = localStorage.getItem('adjustment_orderFromDate');
    this.komFeedModel.orderToDate = localStorage.getItem('adjustment_orderToDate');
    const savedWfindate = localStorage.getItem('adjustment_wfindate');
    this.komFeedModel.wfindate = savedWfindate ? savedWfindate : null;
    this.komFeedModel.sales_rep_id = localStorage.getItem('adjustment_sales_rep_id');

    this.mobileFeedModel.transaction_complete_from_date = localStorage.getItem('adjustment_mobile_transaction_complete_from_date');
    this.mobileFeedModel.transaction_complete_to_date = localStorage.getItem('adjustment_mobile_transaction_complete_to_date');
    this.mobileFeedModel.account_number = localStorage.getItem('adjustment_mobile_account_number');
    this.mobileFeedModel.first_name = localStorage.getItem('adjustment_mobile_first_name');
    this.mobileFeedModel.last_name = localStorage.getItem('adjustment_mobile_last_name');
    this.mobileFeedModel.subscriber_number = localStorage.getItem('adjustment_mobile_subscriber_number');
    this.mobileFeedModel.msisdn = localStorage.getItem('adjustment_mobile_msisdn');
    this.rntFeedModel.rpt_date_from = localStorage.getItem('adjustment_rnt_rpt_date_from');
    this.rntFeedModel.rpt_date_to = localStorage.getItem('adjustment_rnt_rpt_date_to');
    this.rntFeedModel.opr_id = localStorage.getItem('adjustment_rnt_opr_id');
    this.rntFeedModel.retention_type = localStorage.getItem('adjustment_rnt_retention_type');
    this.rntFeedModel.lob = localStorage.getItem('adjustment_rnt_lob');
    this.rntFeedModel.fixedaccountnumber = localStorage.getItem('adjustment_rnt_fixedaccountnumber');
    this.rntFeedModel.mobileaccountnumber = localStorage.getItem('adjustment_rnt_mobileaccountnumber');

    if (!this.mobileFeedModel.account_number) {
      this.mobileFeedModel.account_number = "";
    }

    if (!this.mobileFeedModel.first_name) {
      this.mobileFeedModel.first_name = "";
    }
    if (!this.mobileFeedModel.last_name) {
      this.mobileFeedModel.last_name = "";
    }
    if (!this.mobileFeedModel.subscriber_number) {
      this.mobileFeedModel.subscriber_number = "";
    }
    if (!this.mobileFeedModel.msisdn) {
      this.mobileFeedModel.msisdn = "";
    }

    this.komFeedModel = this.commissionService.komFeedModel;
    this.salesRepData = this.commissionService.salesRepData;
    this.entFeedModel = this.commissionService.entFeedModel;
    this.rntFeedModel = this.commissionService.rntFeedModel;

    this.entFeedModel.orderFromDate = localStorage.getItem('adjustment_ent_orderFromDate');
    this.entFeedModel.orderToDate = localStorage.getItem('adjustment_ent_orderToDate');
    this.entFeedModel.workOrder = localStorage.getItem('adjustment_ent_workOrder');
    this.entFeedModel.status = localStorage.getItem('adjustment_ent_status');

    this.initializeColumns();
    this.checkFeedType();
    this.checkEntFeedType();
    this.getActiveCorps();

    if (this.komFeedModel.adjustmentFeed === "KOM Feed") {
      console.log("Inside IF");
      this.komFeedModel.adjustmentFeed = "KOM Feed";
      this.isKomFeed = true;
    
      this.isMobile = false;
      this.isEntFeed = false;
    
    } else if (this.komFeedModel.adjustmentFeed === "Mobile Feed") {
      console.log("Inside ELSE IF");
      this.komFeedModel.adjustmentFeed = "Mobile Feed";
      this.isMobile = true;
    
      this.isKomFeed = false;
      this.isEntFeed = false;
      this.isRnt = false;
    } else if (this.komFeedModel.adjustmentFeed === "RTN Feed" || this.komFeedModel.adjustmentFeed === "RNT Feed") {
      this.komFeedModel.adjustmentFeed = "RTN Feed";
      this.isRnt = true;
      this.isKomFeed = false;
      this.isMobile = false;
      this.isEntFeed = false;
    
    } else if (this.komFeedModel.adjustmentFeed === "ENT Feed") {
      console.log("Inside ELSE IF ENT Feed");
      this.komFeedModel.adjustmentFeed = "ENT Feed";
      this.isEntFeed = true;  
    
      this.isKomFeed = false;
      this.isMobile = false;
      this.isRnt = false;
    
    } else {
      console.log("Inside ELSE");
      this.komFeedModel.adjustmentFeed = "KOM Feed";
      this.isKomFeed = true;
    
      this.isMobile = false;
      this.isEntFeed = false;
      this.isRnt = false;
    }
    
    console.log(this.komFeedModel.adjustmentFeed);    
  }

  resetFields() {
    console.log(this.komFeedModel.adjustmentFeed);
    if (this.komFeedModel.adjustmentFeed === "KOM Feed") {
      console.log("Inside IF");
      this.komFeedModel.corp = null;
      this.komFeedModel.house = null;
      this.komFeedModel.orderFromDate = null;
      this.komFeedModel.orderToDate = null;
      this.komFeedModel.wfindate = null;
      this.komFeedModel.sales_rep_id = null;
    } else if (this.komFeedModel.adjustmentFeed === "Mobile Feed") {
      console.log("Inside ELSE");
      this.mobileFeedModel.transaction_complete_from_date = null;
      this.mobileFeedModel.transaction_complete_to_date = null;
      this.mobileFeedModel.account_number = "";
      this.mobileFeedModel.first_name = "";
      this.mobileFeedModel.last_name = "";
      this.mobileFeedModel.subscriber_number = "";
      this.mobileFeedModel.msisdn = "";
    } else if (this.komFeedModel.adjustmentFeed === "RTN Feed" || this.komFeedModel.adjustmentFeed === "RNT Feed") {
      this.rntFeedModel.rpt_date_from = null;
      this.rntFeedModel.rpt_date_to = null;
      this.rntFeedModel.opr_id = null;
      this.rntFeedModel.retention_type = null;
      this.rntFeedModel.lob = null;
      this.rntFeedModel.fixedaccountnumber = null;
      this.rntFeedModel.mobileaccountnumber = null;
      this.rntFeedModel.accountstatuseoi = null;
      this.rntFeedModel.accountstatuseod30 = null;
      this.rntFeedModel.accountstatuseod60 = null;
      this.rntFeedModel.productdesceoi = null;
      this.rntFeedModel.productdesceod30 = null;
      this.rntFeedModel.productdesceod60 = null;
      this.rntFeedModel.workorderstatus = null;
      this.rntFeedModel.save_type = null;
      this.rntFeedModel.call_type = null;
      this.rntFeedModel.customer_class = null;
    }
    else if (this.komFeedModel.adjustmentFeed === "ENT Feed") {
      this.entFeedModel.orderFromDate = null;
      this.entFeedModel.orderToDate = null;
      this.entFeedModel.workOrder = null;
      (this.entFeedModel as any).order_id = null;
      (this.entFeedModel as any).enterpriseStatus = null;
      this.entFeedModel.status = null;
    }
  }

  searchResults() {
    // this.komFeedModel.adjustmentFeed = "KOM Feed";
    console.log("searchResults() called");
    if (!this.komFeedModel.adjustmentFeed) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select AdjustmentFeed');
    } else if (!this.komFeedModel.corp) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please Select Corp');
    } else if (!this.komFeedModel.house) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please Enter House');
    } else if (!this.komFeedModel.orderFromDate) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select OrderFromDate');
    } else if (!this.komFeedModel.orderToDate) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select OrderToDate');
    } else {
      if (!this.komFeedModel.wfindate) {
        this.komFeedModel.wfindate = null;
      }
      this.commissionService.komFeedModel = this.komFeedModel;
      //console.log(this.commissionService.komFeedModel);
      this.komFeedService.getFeedSerchResults(this.commissionService.komFeedModel).
        subscribe((data: KomFeed[]) => {
          this.feedResultsData = data;
          console.log(this.feedResultsData);

          localStorage.setItem('adjustment_komfeed', this.komFeedModel.adjustmentFeed);
          localStorage.setItem('adjustment_corp', this.komFeedModel.corp);
          localStorage.setItem('adjustment_house', this.komFeedModel.house);
          localStorage.setItem('adjustment_orderFromDate', this.komFeedModel.orderFromDate);
          localStorage.setItem('adjustment_orderToDate', this.komFeedModel.orderToDate);
          localStorage.setItem('adjustment_wfindate', this.komFeedModel.wfindate || '');
          localStorage.setItem('adjustment_sales_rep_id', this.komFeedModel.sales_rep_id);

          if (this.feedResultsData?.length > 0)
            this.router.navigate(['/feed-results']);
          else
            this.notificationService.sendNotification(NotificationType.WARNING, 'No Records Found');
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });

    }
  }

  searchEnterpriseResults() {
   
    console.log("searchEnterpriseResults() called");
    this.entFeedModel.isEntRelease = false;
    this.entFeedModel.isEnterprise = true;
    localStorage.setItem('ent_is_release', 'N');
  
    this.commissionService.entFeedModel = { ...this.entFeedModel };
    this.commissionService.entFeedModel.isEnterprise = true;
    this.commissionService.entFeedModel.isEntRelease = false;
  
    (this.commissionService.entFeedModel as any).status =
      (this.commissionService.entFeedModel as any).enterpriseStatus || null;
    if (!this.commissionService.entFeedModel.workOrder?.trim()) {
      this.commissionService.entFeedModel.workOrder = null;
    }
    this.entFeedModel = this.commissionService.entFeedModel;
    console.log(this.commissionService.entFeedModel);
    this.komFeedService.getEnterpriseResults(this.commissionService.entFeedModel).
        subscribe((data: EntFeed[]) => {
          this.entFeedResultsData = data;
          console.log(this.entFeedResultsData);

          localStorage.setItem('adjustment_komfeed', this.entFeedModel.adjustmentFeed);
          localStorage.setItem('adjustment_orderFromDate', this.entFeedModel.orderFromDate);
          localStorage.setItem('adjustment_orderToDate', this.entFeedModel.orderToDate);
          localStorage.setItem('adjustment_status', this.entFeedModel.status);
          //localStorage.setItem('adjustment_sales_rep_id', this.entFeedModel.workOrder);

          if (this.entFeedResultsData?.length > 0)
            this.router.navigate(['/ent-feed-results']);
          else
            this.notificationService.sendNotification(NotificationType.WARNING, 'No Records Found');
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });

    
  }

  searchEntReleaseResults() {

    console.log("searchEntReleaseResults() called");
  
    this.entFeedModel.isEnterprise = false;
    this.entFeedModel.isEntRelease = true;
  
    localStorage.setItem('ent_is_release', 'Y');
  
    this.commissionService.entFeedModel = { ...this.entFeedModel };
    this.commissionService.entFeedModel.isEnterprise = false;
    this.commissionService.entFeedModel.isEntRelease = true;
  

    (this.commissionService.entFeedModel as any).status =
      (this.commissionService.entFeedModel as any).enterpriseStatus || null;
    if (!this.commissionService.entFeedModel.workOrder?.trim()) {
      this.commissionService.entFeedModel.workOrder = null;
    }
    this.entFeedModel = this.commissionService.entFeedModel;

    console.log(this.commissionService.entFeedModel);

    this.komFeedService.getEntReleaseResults(this.commissionService.entFeedModel)
      .subscribe((data: EntFeed[]) => {
        this.entFeedResultsData = data;
        console.log(this.entFeedResultsData);
  
        localStorage.setItem('adjustment_komfeed', this.entFeedModel.adjustmentFeed);
        localStorage.setItem('adjustment_orderFromDate', this.entFeedModel.orderFromDate);
        localStorage.setItem('adjustment_orderToDate', this.entFeedModel.orderToDate);
        localStorage.setItem('adjustment_status', this.entFeedModel.status);
  
        if (this.entFeedResultsData?.length > 0)
          this.router.navigate(['/ent-feed-results']);
        else
          this.notificationService.sendNotification(NotificationType.WARNING, 'No Records Found');
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }
  


  searchMobileFeedResults() {
    // this.komFeedModel.adjustmentFeed = "Mobile Feed";
    console.log("searchMobileFeedResults() called");
    if (!this.mobileFeedModel.transaction_complete_from_date) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select From Date');
    } else if (!this.mobileFeedModel.transaction_complete_to_date) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please Select To Date');
    } else {

      localStorage.setItem('adjustment_mobile_transaction_complete_from_date', this.mobileFeedModel.transaction_complete_from_date);
      localStorage.setItem('adjustment_mobile_transaction_complete_to_date', this.mobileFeedModel.transaction_complete_to_date);
      localStorage.setItem('adjustment_mobile_account_number', this.mobileFeedModel.account_number);
      localStorage.setItem('adjustment_mobile_first_name', this.mobileFeedModel.first_name);
      localStorage.setItem('adjustment_mobile_last_name', this.mobileFeedModel.last_name);
      localStorage.setItem('adjustment_mobile_subscriber_number', this.mobileFeedModel.subscriber_number);
      localStorage.setItem('adjustment_mobile_msisdn', this.mobileFeedModel.msisdn);

      if (!this.mobileFeedModel.account_number) {
        this.mobileFeedModel.account_number = "";
      }
      if (!this.mobileFeedModel.first_name) {
        this.mobileFeedModel.first_name = "";
      }
      if (!this.mobileFeedModel.last_name) {
        this.mobileFeedModel.last_name = "";
      }
      if (!this.mobileFeedModel.subscriber_number) {
        this.mobileFeedModel.subscriber_number = "";
      }
      if (!this.mobileFeedModel.msisdn) {
        this.mobileFeedModel.msisdn = "";
      }

      this.commissionService.mobileFeedModel = this.mobileFeedModel;
      console.log(this.commissionService.mobileFeedModel);

      this.komFeedService.getMobileFeedSerchResults(this.commissionService.mobileFeedModel).
        subscribe((data: MobileFeedModel[]) => {
          this.mobileFeedResultsData = data;
          console.log(this.mobileFeedResultsData);



          if (this.mobileFeedResultsData?.length > 0)
            this.router.navigate(['/mobile-results']);
          else
            this.notificationService.sendNotification(NotificationType.WARNING, 'No Records Found');
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });

    }
  }

  searchRntFeedResults() {
    if (!this.rntFeedModel.rpt_date_from) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select Report From Date');
    } else if (!this.rntFeedModel.rpt_date_to) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select Report To Date');
    } else {
      const chunkSize = this.commissionService.rntFeedChunkSize;
      this.rntFeedModel.limit = chunkSize;
      this.rntFeedModel.offset = 0;
      this.commissionService.rntFeedModel = this.rntFeedModel;
      localStorage.setItem('adjustment_rnt_rpt_date_from', this.rntFeedModel.rpt_date_from);
      localStorage.setItem('adjustment_rnt_rpt_date_to', this.rntFeedModel.rpt_date_to);
      localStorage.setItem('adjustment_rnt_opr_id', this.rntFeedModel.opr_id ?? '');
      localStorage.setItem('adjustment_rnt_retention_type', this.rntFeedModel.retention_type ?? '');
      localStorage.setItem('adjustment_rnt_lob', this.rntFeedModel.lob ?? '');
      localStorage.setItem('adjustment_rnt_fixedaccountnumber', this.rntFeedModel.fixedaccountnumber ?? '');
      localStorage.setItem('adjustment_rnt_mobileaccountnumber', this.rntFeedModel.mobileaccountnumber ?? '');

      this.komFeedService.getRntFeedSearchResults(this.commissionService.rntFeedModel)
        .subscribe((page) => {
          const rows = page?.rows || [];
          this.rntFeedResultsData = rows;
          this.commissionService.rntFeedResultsData = rows;
          this.commissionService.rntFeedTotalCount = page?.total ?? rows.length;
          this.commissionService.rntFeedChunkCache = { 0: rows };
          if (rows.length > 0) {
            this.router.navigate(['/rnt-results']);
          } else {
            this.notificationService.sendNotification(NotificationType.WARNING, 'No Records Found');
          }
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
  }

  searchFreeForm() {
    console.log("searchFreeForm() called");
    if (!this.komFeedModel.adjustmentFeed) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select AdjustmentFeed');
    } else {
      this.commissionService.getFreeFormSerchResults(this.freeForm.searchWith).
        subscribe((data: FreeForm[]) => {
          this.freeFormResult = data;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    }
  }

  public getActiveCorps(): void {
    console.log("getActiveCorps called");
    this.manageRegionsService.getActiveCorps().subscribe(
      (response: RegionsModel[]) => {
        this.corpsList = response;
        this.corpsList = this.corpsList.filter((v, i) => this.corpsList.findIndex(item => item.id == v.id) === i);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }
  checkFeedType() {
    if (this.komFeedModel.adjustmentFeed === 'KOM Feed') {
      this.isKomFeed = true;
      this.isRetention = false;
      this.isMobile = false;
      this.isCall = false;
      this.isAll = false;
      this.isRnt = false;
      this.isEntFeed = false;   // ✅ add
    } else if (this.komFeedModel.adjustmentFeed === 'KOM Feed Retention') {
      this.isRetention = true;
      this.isKomFeed = false;
      this.isMobile = false;
      this.isCall = false;
      this.isAll = false;
      this.isRnt = false;
      this.isEntFeed = false;   // ✅ add
    } else if (this.komFeedModel.adjustmentFeed === 'Mobile Feed') {
      this.isMobile = true;
      this.isRetention = false;
      this.isKomFeed = false;
      this.isCall = false;
      this.isAll = false;
      this.isRnt = false;
      this.isEntFeed = false;   // ✅ add
    } else if (this.komFeedModel.adjustmentFeed === 'RTN Feed' || this.komFeedModel.adjustmentFeed === 'RNT Feed') {
      this.komFeedModel.adjustmentFeed = 'RTN Feed';
      this.isRnt = true;
      this.isMobile = false;
      this.isRetention = false;
      this.isKomFeed = false;
      this.isCall = false;
      this.isAll = false;
      this.isEntFeed = false;
      this.loadRntFilterOptions();
    } else if (this.komFeedModel.adjustmentFeed === 'ENT Feed') {
      this.isEntFeed = true;    // ✅ add ENT branch
      this.isKomFeed = false;
      this.isRetention = false;
      this.isMobile = false;
      this.isCall = false;
      this.isAll = false;
      this.isRnt = false;
    } else if (this.komFeedModel.adjustmentFeed === 'Call Details') {
      this.isCall = true;
      this.isRetention = false;
      this.isKomFeed = false;
      this.isMobile = false;
      this.isAll = false;
      this.isRnt = false;
      this.isEntFeed = false;   // ✅ add
    } else if (this.komFeedModel.adjustmentFeed === 'All') {
      this.isAll = true;
      this.isRetention = false;
      this.isKomFeed = false;
      this.isMobile = false;
      this.isCall = false;
      this.isRnt = false;
      this.isEntFeed = false;   // ✅ add
    }
  }
  checkEntFeedType() {
    if (this.isEntFeed && this.komFeedModel.entAdjustmentFeed === 'Enterprise Data') {
      this.entFeedModel.isEnterprise = true;
      this.isEnterprise = true;
      this.entFeedModel.isEntRelease = false;
      this.isEntRelease = false;

    } else if (this.komFeedModel.entAdjustmentFeed === 'Enterprise Release Data') {
      this.entFeedModel.isEntRelease = true;
      this.isEntRelease = true;
      this.entFeedModel.isEnterprise = false;
      this.isEnterprise = false;
    }
  }  
  

  onChangeDt() {
    console.log("onChangeDt");
    this.komFeedModel.orderFromDate = this.datePipe.transform(this.komFeedModel.orderFromDate, "yyyy-MM-dd");
    this.komFeedModel.orderToDate = this.datePipe.transform(this.komFeedModel.orderToDate, "yyyy-MM-dd");

    console.log(this.komFeedModel);

    this.komFeedService.getSalesRepIds(this.komFeedModel).subscribe((data: KomFeed[]) => {
      this.salesRepData = data;
      console.log(this.salesRepData);
      this.commissionService.salesRepData = this.salesRepData;

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  onKomFromDateChange() {
    if (this.komFeedModel?.orderFromDate && this.komFeedModel?.orderToDate) {
      if (this.komFeedModel.orderToDate < this.komFeedModel.orderFromDate) {
        this.komFeedModel.orderToDate = null;
      }
    }
  }

  onMobileFromDateChange() {
    if (this.mobileFeedModel?.transaction_complete_from_date && this.mobileFeedModel?.transaction_complete_to_date) {
      if (this.mobileFeedModel.transaction_complete_to_date < this.mobileFeedModel.transaction_complete_from_date) {
        this.mobileFeedModel.transaction_complete_to_date = null;
      }
    }
  }

  onEntFromDateChange() {
    if (this.entFeedModel?.orderFromDate && this.entFeedModel?.orderToDate) {
      if (this.entFeedModel.orderToDate < this.entFeedModel.orderFromDate) {
        this.entFeedModel.orderToDate = null;
      }
    }
  }
  
  searchCallResults() {
    this.commissionService.callDetailModel = this.callDetailModel;
    this.komFeedService.getCallDataResult(this.callDetailModel).
      subscribe((data: CallDetails[]) => {
        this.feedCallResultsData = data;
        if (this.feedCallResultsData?.length > 0) {
          console.log(this.feedCallResultsData);
          this.router.navigate(['/call-data']);
        }
        else
          this.notificationService.sendNotification(NotificationType.WARNING,
            'Records are not existing');
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }
  innerRowAction1(row: any) {

    if (row.value === 'View') {
      this.komFeedModel.sales_rep_id = row.row.salesRepId;
      this.komFeedModel.wordate = row.row.searchDate;
      this.chc = row.row.searchString.split('-');
      this.komFeedModel.corp = this.chc[0];
      this.komFeedModel.house = this.chc[1];
      console.log(this.chc);
      this.komFeedService.getFeedSerchResults(this.commissionService.komFeedModel).
        subscribe((data: KomFeed[]) => {
          this.feedResultsData = data;
          if (this.feedResultsData.length > 0)
            this.router.navigate(['/feed-results']);
          else
            this.notificationService.sendNotification(NotificationType.WARNING, 'For the select SalesRepID Records are not existing');
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });

    }
  }
  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.FreeFormRes;
        console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  /** Loads all RNT dropdown options when RNT Feed is selected (server caches for 1 hour). */
  loadRntFilterOptions() {
    if (this.rntMainFilterOptionsLoaded) {
      return;
    }
    this.komFeedService.getRntFilterOptions().subscribe((data: any) => {
      this.rntFilterOptions = data || {};
      this.rntMainFilterOptionsLoaded = true;
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }
}
